import React, {useEffect, useRef, useState} from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip'
import './styles/main.css';
import './styles/index.css'
import './styles/cover.css'
import './styles/locateus.css'
import Header from "./components/Header";
import Cover from './components/Cover';
import Services from "./containers/Services";
import AboutUs from "./containers/AboutUs";
import ContactUs from "./containers/ContactUs";
import LocateUs from "./containers/LocateUs";
import Scroll from "react-scroll";
import MapContainer from "./containers/MapContainer";

const goToLink = (idVal) => {
    const Scroller = Scroll.scroller;
    Scroller.scrollTo(idVal, {
        smooth: true,
        offset: -60,
        activeClass: 'activeLink'
    })
}

export default function Main() {
    const [isSticky, setSticky] = useState(false);
    const ref = useRef(null);
    const handleScroll = () => {
        if (ref.current) {
            setSticky(ref.current.getBoundingClientRect().top <= 0);
        }
    };
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', () => handleScroll);
        };
    }, []);

    const renderTooltip = (props) => {
        return (
            <Tooltip id="button-tooltip" {...props}>
                Click to WhatsApp us!
            </Tooltip>
        );
    };


    return (
        <div id="home-link" className="index-main">
            <div className={`sticky-wrapper${isSticky ? 'main sticky' : 'main'}`} ref={ref}>
                <Header goToLink={goToLink}/>
            </div>
            <div className="main">
                <div className="row padding-bottom">
                    <Cover/>
                </div>
                <div id="services-link" className="row padding-bottom">
                    <Services/>
                </div>
                <div id="about-link" className="row">
                    <AboutUs/>
                </div>
                {/*<div id="contact-link" className="row">*/}
                    {/*<ContactUs/>*/}
                {/*</div>*/}
                <div id="locate-link" className="row">
                    <LocateUs/>
                </div>
                <div className="row padding-around-more">
                    <div className="outer-container-map">
                        <MapContainer/>
                    </div>

                </div>

                <div className="row padding-bottom-extra">
                </div>
                <div className="fixed-footer-parent">
                    <div className="whatsapp-footer">
                        <OverlayTrigger
                            placement="left"
                            delay={{show: 250, hide: 400}}
                            overlay={renderTooltip}>
                            <a href="https://wa.me/919892079970" target="_blank">
                                {/*<button className="round-button">*/}
                                    <i className="fa fa-whatsapp fa-3x whatsapp-button"/>
                                {/*</button>*/}
                            </a>
                        </OverlayTrigger>

                    </div>
                </div>


            </div>
        </div>
    );
}